import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { ProgramService } from '../program.service';
import { ConfigurareProgram } from '../program.interface';
import { dateRangeValidator } from 'src/app/validators/date-period';

@Component({
    selector: 'app-configurare-program',
    templateUrl: './configurare-program.component.html',
    styleUrls: ['./configurare-program.component.scss']
})
export class ConfigurareProgramComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    durataOptions: { name: string; value: number }[] = [
        { name: '-- Alegeți --', value: -1 },
        { name: '5 minute', value: 5 },
        { name: '10 minute', value: 10 },
        { name: '15 minute', value: 15 },
        { name: '20 minute', value: 20 },
        { name: '25 minute', value: 25 },
        { name: '30 minute', value: 30 },
        { name: '35 minute', value: 35 },
        { name: '40 minute', value: 40 },
        { name: '45 minute', value: 45 },
        { name: '50 minute', value: 50 },
        { name: '55 minute', value: 55 },
        { name: '60 minute', value: 60 },
    ]

    form: FormGroup = new FormGroup({
        durata_interval_blocare: new FormControl(this.data.configuration?.durata_interval_blocare ? this.data.configuration.durata_interval_blocare : -1, Validators.required),
        durata_programare: new FormControl(this.data.configuration?.durata_programare ? this.data.configuration.durata_programare : -1, Validators.required),
        min_date_available: new FormControl(this.data.configuration?.min_date_available ? this.data.configuration.min_date_available : '', Validators.required),
        max_date_available: new FormControl(this.data.configuration?.max_date_available ? this.data.configuration.max_date_available : '', Validators.required),
    }, { validators: dateRangeValidator('min_date_available', 'max_date_available') });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<ConfigurareProgramComponent>,
        private programService: ProgramService,
        private notificationService: NotificationService,
    ) {
        console.log(this.data);
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    submitForm() {
        this.isLoading = true;

        const { durata_interval_blocare, durata_programare, min_date_available, max_date_available } = this.form.value as any;

        const configuration: ConfigurareProgram = {
            durata_interval_blocare,
            durata_programare,
            max_date_available: max_date_available ? this.formatDate(max_date_available) : '',
            min_date_available: min_date_available ? this.formatDate(min_date_available) : '',
        };

        this.programService
            .updateConfiguration(this.data.id, configuration)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
